/*
Manage a user's state and login information

https://jsdaddy.github.io/ngx-mask-page/main

*/

import { get, writable } from 'svelte/store';
import firebase from './firebase';
import { firestore } from './firebase';
import { GetDoc } from './database';
import Cookies from 'js-cookie';
import * as utils from './utils.js';

// hold all information about the currently signed in user
export const curUser = writable(null);

// Get the firestore user info from the database. Resolve any PendingGetUsers if
// something is found

export function SignIn(email, password, goTo)
{
    email = email.toLowerCase();
    return new Promise((resolve, reject) =>
    {
        firebase.auth().signInWithEmailAndPassword(email, password)
            .then((result) => {
                resolve();
            })
            .catch((error) => {
                reject(error)
            });
    });
}

let pendingGetUser = [];
export function Get()
{
    return new Promise((resolve, reject) =>
    {
        if (get(curUser))
        {
            resolve(get(curUser))
        }
        else
        {
            pendingGetUser.push(resolve);
        }
    });
}

let authUser = null;
let authState = 'unknown';
let pendingAuthGets = [];

// delivers the user object to everybody waiting on it
function _ResolvePendingAuthGets()
{
    for (let resolve of pendingAuthGets)
    {
        try {
            resolve(authUser);
        } catch (e) { console.log(e); }
    }
    pendingAuthGets = [];
}


export function GetAuthOnly()
{
    return new Promise((resolve, reject) =>
    {
        if (authState === 'unknown')
        {
            pendingAuthGets.push(resolve);
        }
        else
        {
            resolve(authUser);
        }
    });
}


// update the firestore collection information on this user
export function Update(uid, args)
{
    return new Promise((resolve, reject) =>
    {
        let now = utils.Now();
        args.lastmod = now;
        firestore.collection('User').doc(uid).update(args).then(() => {
            let u = get(curUser);
            
            // update the curUser and reset to notify people
            Object.assign(u, args);
            curUser.set(u);

            resolve();
        })
    });
}

// delivers the user object to everybody waiting on it
function _ResolvePendingGetUser()
{
    for (let resolve of pendingGetUser)
    {
        try {
            resolve(get(curUser));
        } catch (e) { console.log(e); }
    }
    pendingGetUser = [];
}

export function SignOut()
{
    console.log('please sign out');
    firebase.auth().signOut().then(() => 
    {
        // I think this is what we will want to do at some point
        window.location.href = '/';
    });
}

// Create the firebase user
export function CreateAuthUser(email, password) //, firstName, lastName, phone, providerType)
{

    return new Promise((resolve, reject) =>
    {
        email = email.toLowerCase();
        // at the end of this make sure to resolve any pending get users
        firebase.auth().createUserWithEmailAndPassword(email, password)
            .then((firebaseUser) => {

                let now = utils.Now();
                let uid = firebaseUser.user.uid;

                utils.log('Firebase Auth Created', email, uid);

                let data = {
                    signUpState:'needsverify',
                    subscriptionState:'none',
                    email,
                    created:now,
                    lastmod:now,
                    providerId:firebaseUser.additionalUserInfo.providerId
                };

                // now create the firestore user
                firestore.collection('User').doc(uid).set(data).then(() => {
                    // set the current user
                    utils.log("Firestore User created", data);

                    data.id = uid;
                    data.emailVerified = false;
                    data.auth = firebaseUser.user;

                    resolve(data);

                    curUser.set(data);
                    _ResolvePendingGetUser();
                })
                .catch((error) =>
                {
                    utils.error('Firestore User Error', error);
                    reject(error);
                });

            })
            .catch((error) => {
                let errorCode = error.code;
                let errorMessage = error.message;
                reject(errorCode);
            });
    });
}

firebase.auth().onAuthStateChanged(function(user) {
    // this is the authority if someone is signed in, and we have to wait for it to respond
    // until we are sure if the user is signed in or not

    console.log("onAuthStatechanged", user);

    authUser = user;
    authState = user ? 'signed-in' : 'no-session';
    _ResolvePendingAuthGets();

    if (user)
    {
        // grab their full record
        GetDoc('User', user.uid).then(u =>
        {
            // set the user
            u.emailVerified = user.emailVerified;
            u.auth = user;
            curUser.set(u)

            _ResolvePendingGetUser();
        })
        .catch((error) =>
        {
            console.log(error);
            curUser.set({auth:user});
            //curUser.set(null);
        });
    }
    else
    {
        curUser.set({});
        _ResolvePendingGetUser();
    }
});


// send Email but make sure we don't send them too often
export function SendEmailVerification()
{
    console.log("SendEmailVerification");
    GetAuthOnly().then((u) =>
    {
        console.log("GetAuthOnly returned");
        if (u)
        {
            // see if there is a cookie for this
            if (Cookies.get(authUser.uid+'email'))
            {
                utils.log('EmailVerify already sent', authUser.email);
                return;
            }

            // give it a minute before we attempt to send another one
            const expire = new Date(new Date().getTime() + (30 * 1000));
            Cookies.set(authUser.uid+'email', '1', {expires:expire});

            authUser.sendEmailVerification();
            utils.log('Email Verify Sent', authUser.email);

        }
        
    })
    .catch((error) => 
    {
        utils.error('Failed to send email');   
    });
}


export function ToLitmos()
{
    // grab a fresh copy of the user from the database. Make sure they a) have a valid subscription
    // and b) have a litmos account. If no litmos account exists, then create one first
    console.log('Got called')
    utils.log("ToLitmos");
    Get().then((u) =>
    {
        if (!u)
        {
            utils.log("ToLitmos no user record", push);
            // send them to a login redirect
            utils.RequestSignIn($location);
            return;
        }

        // make sure they are subscribed... if not send them to either
        //  - The page to update payment if we already have some
        //  - The page to complete payment information if they haven't
        /*
        if (u.subscription === 'active')
        {

        }
        */
        CloudCall('getLitmosLogin', {}).then(res =>
        {
            window.location.href = res.data.LoginKey;
        })
        .catch((error) =>
        {
            utils.error("_OpenLitmos Error", error);
        });


        /*
        // see if there is a litmos account for this user
        console.log('what in the world', u);
        if (!u.litmosID)
        {
            utils.log("Create Litmos Account");
            // create it
            CloudCall('createLitmosAccount', {}).then(res =>
            {
                console.log('the restul from my cloud call', res);
                _OpenLitmos();
            });
        }
        else
        {
            _OpenLitmos();
        }
        */

    })
    .catch((error) =>
    {
        // Handle this
        utils.error("ToLitmos Error", error);
        if (error === 'no-auth')
        {
            utils.RequestSignIn(); //$location);
        }
    });
}

